module.exports = __webpack_public_path__ + "img/ic_align-right.675d4878.svg";